import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllTournament from '../tournament/AllTournament'
import ViewTournament from '../tournament/ViewTournament'
import UpdateTournament from '../tournament/UpdateTournament'
import AddTournament from '../tournament/AddTournament'

function TournamentRoute() {
  return (
    <>
      <Routes>
        <Route path='/all-tournament' element={<AllTournament/>}/>
        <Route path='/view-tournament' element={<ViewTournament/>}/>
        <Route path='/update-tournament' element={<UpdateTournament/>}/>
        <Route path='/add-tournament' element={<AddTournament/>}/>
      </Routes>
    </>
  )
}

export default TournamentRoute
